export const stripControlChars = (value = "") => value.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "").trim();

export const stripControlCharsNoTrim = (value = "") => value.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "");

export const sanitizeTextInput = (value = "", maxLength = 255) => stripControlChars(value).slice(0, maxLength);

export const sanitizeTextInputNoTrim = (value = "", maxLength = 255) => stripControlCharsNoTrim(value).slice(0, maxLength);

export const sanitizeEmailInput = (value = "") => stripControlChars(value.toLowerCase()).split(/[^a-z0-9@._+-]/)[0].slice(0, 254);

export const sanitizeUsernameInput = (value = "") => sanitizeTextInput(value, 30).replace(/[^A-Za-z0-9._-]/g, "");